const points = [
    [0, 0]
    ,
    [0, 1]
    ,
    [0, 2]
    ,
    [0, 3]
    ,
    [0, 4]
    ,
    [0, 5]
    ,
    [0, 6]
    ,
    [0, 7]
    ,
    [0, 8]
    ,
    [0, 9]
    ,
    [0, 10]
    ,
    [0, 11]
    ,
    [0, 12]
    ,
    [0, 13]
    ,
    [0, 14]
    ,
    [0, 15]
    ,
    [0, 16]
    ,
    [0, 19]
    ,
    [0, 20]
    ,
    [0, 21]
    ,
    [0, 22]
    ,
    [0, 23]
    ,
    [0, 24]
    ,
    [0, 25]
    ,
    [0, 26]
    ,
    [0, 27]
    ,
    [0, 28]
    ,
    [0, 29]
    ,
    [0, 34]
    ,
    [0, 35]
    ,
    [0, 36]
    ,
    [0, 37]
    ,
    [0, 38]
    ,
    [0, 39]
    ,
    [0, 40]
    ,
    [0, 41]
    ,
    [0, 42]
    ,
    [0, 43]
    ,
    [0, 44]
    ,
    [0, 45]
    ,
    [0, 46]
    ,
    [0, 47]
    ,
    [0, 48]
    ,
    [0, 49]
    ,
    [0, 50]
    ,
    [0, 51]
    ,
    [0, 52]
    ,
    [0, 53]
    ,
    [0, 54]
    ,
    [0, 55]
    ,
    [0, 56]
    ,
    [0, 57]
    ,
    [0, 58]
    ,
    [0, 59]
    ,
    [0, 60]
    ,
    [0, 61]
    ,
    [0, 62]
    ,
    [1, 0]
    ,
    [1, 16]
    ,
    [1, 19]
    ,
    [1, 30]
    ,
    [1, 34]
    ,
    [1, 43]
    ,
    [1, 52]
    ,
    [1, 62]
    ,
    [2, 0]
    ,
    [2, 4]
    ,
    [2, 5]
    ,
    [2, 6]
    ,
    [2, 7]
    ,
    [2, 8]
    ,
    [2, 16]
    ,
    [2, 19]
    ,
    [2, 30]
    ,
    [2, 34]
    ,
    [2, 43]
    ,
    [2, 52]
    ,
    [2, 62]
    ,
    [3, 0]
    ,
    [3, 4]
    ,
    [3, 5]
    ,
    [3, 6]
    ,
    [3, 8]
    ,
    [3, 9]
    ,
    [3, 10]
    ,
    [3, 11]
    ,
    [3, 12]
    ,
    [3, 16]
    ,
    [3, 19]
    ,
    [3, 24]
    ,
    [3, 25]
    ,
    [3, 26]
    ,
    [3, 27]
    ,
    [3, 30]
    ,
    [3, 34]
    ,
    [3, 37]
    ,
    [3, 38]
    ,
    [3, 39]
    ,
    [3, 40]
    ,
    [3, 43]
    ,
    [3, 46]
    ,
    [3, 47]
    ,
    [3, 48]
    ,
    [3, 49]
    ,
    [3, 52]
    ,
    [3, 56]
    ,
    [3, 57]
    ,
    [3, 58]
    ,
    [3, 59]
    ,
    [3, 62]
    ,
    [4, 0]
    ,
    [4, 6]
    ,
    [4, 12]
    ,
    [4, 16]
    ,
    [4, 19]
    ,
    [4, 24]
    ,
    [4, 27]
    ,
    [4, 30]
    ,
    [4, 34]
    ,
    [4, 37]
    ,
    [4, 40]
    ,
    [4, 43]
    ,
    [4, 46]
    ,
    [4, 49]
    ,
    [4, 52]
    ,
    [4, 55]
    ,
    [4, 59]
    ,
    [4, 62]
    ,
    [5, 0]
    ,
    [5, 6]
    ,
    [5, 12]
    ,
    [5, 16]
    ,
    [5, 17]
    ,
    [5, 18]
    ,
    [5, 19]
    ,
    [5, 24]
    ,
    [5, 27]
    ,
    [5, 30]
    ,
    [5, 31]
    ,
    [5, 32]
    ,
    [5, 33]
    ,
    [5, 34]
    ,
    [5, 37]
    ,
    [5, 40]
    ,
    [5, 43]
    ,
    [5, 46]
    ,
    [5, 49]
    ,
    [5, 52]
    ,
    [5, 55]
    ,
    [5, 59]
    ,
    [5, 62]
    ,
    [5, 63]
    ,
    [6, 0]
    ,
    [6, 1]
    ,
    [6, 2]
    ,
    [6, 3]
    ,
    [6, 6]
    ,
    [6, 12]
    ,
    [6, 24]
    ,
    [6, 27]
    ,
    [6, 37]
    ,
    [6, 40]
    ,
    [6, 46]
    ,
    [6, 49]
    ,
    [6, 55]
    ,
    [6, 59]
    ,
    [6, 63]
    ,
    [6, 64]
    ,
    [7, 3]
    ,
    [7, 6]
    ,
    [7, 12]
    ,
    [7, 24]
    ,
    [7, 27]
    ,
    [7, 37]
    ,
    [7, 40]
    ,
    [7, 46]
    ,
    [7, 49]
    ,
    [7, 55]
    ,
    [7, 59]
    ,
    [7, 64]
    ,
    [7, 65]
    ,
    [8, 3]
    ,
    [8, 6]
    ,
    [8, 12]
    ,
    [8, 13]
    ,
    [8, 14]
    ,
    [8, 15]
    ,
    [8, 16]
    ,
    [8, 17]
    ,
    [8, 18]
    ,
    [8, 19]
    ,
    [8, 20]
    ,
    [8, 21]
    ,
    [8, 22]
    ,
    [8, 23]
    ,
    [8, 24]
    ,
    [8, 27]
    ,
    [8, 28]
    ,
    [8, 29]
    ,
    [8, 30]
    ,
    [8, 31]
    ,
    [8, 32]
    ,
    [8, 33]
    ,
    [8, 34]
    ,
    [8, 35]
    ,
    [8, 36]
    ,
    [8, 37]
    ,
    [8, 40]
    ,
    [8, 41]
    ,
    [8, 42]
    ,
    [8, 43]
    ,
    [8, 44]
    ,
    [8, 45]
    ,
    [8, 46]
    ,
    [8, 49]
    ,
    [8, 55]
    ,
    [8, 59]
    ,
    [8, 65]
    ,
    [9, 3]
    ,
    [9, 6]
    ,
    [9, 49]
    ,
    [9, 50]
    ,
    [9, 51]
    ,
    [9, 52]
    ,
    [9, 53]
    ,
    [9, 54]
    ,
    [9, 55]
    ,
    [9, 60]
    ,
    [9, 65]
    ,
    [10, 3]
    ,
    [10, 6]
    ,
    [10, 10]
    ,
    [10, 11]
    ,
    [10, 12]
    ,
    [10, 13]
    ,
    [10, 14]
    ,
    [10, 15]
    ,
    [10, 16]
    ,
    [10, 17]
    ,
    [10, 18]
    ,
    [10, 19]
    ,
    [10, 20]
    ,
    [10, 21]
    ,
    [10, 22]
    ,
    [10, 23]
    ,
    [10, 24]
    ,
    [10, 25]
    ,
    [10, 26]
    ,
    [10, 27]
    ,
    [10, 28]
    ,
    [10, 29]
    ,
    [10, 30]
    ,
    [10, 31]
    ,
    [10, 33]
    ,
    [10, 34]
    ,
    [10, 35]
    ,
    [10, 36]
    ,
    [10, 37]
    ,
    [10, 38]
    ,
    [10, 39]
    ,
    [10, 40]
    ,
    [10, 41]
    ,
    [10, 42]
    ,
    [10, 43]
    ,
    [10, 44]
    ,
    [10, 45]
    ,
    [10, 46]
    ,
    [10, 61]
    ,
    [10, 65]
    ,
    [11, 3]
    ,
    [11, 6]
    ,
    [11, 10]
    ,
    [11, 31]
    ,
    [11, 33]
    ,
    [11, 46]
    ,
    [11, 47]
    ,
    [11, 62]
    ,
    [11, 65]
    ,
    [12, 3]
    ,
    [12, 6]
    ,
    [12, 10]
    ,
    [12, 31]
    ,
    [12, 33]
    ,
    [12, 47]
    ,
    [12, 62]
    ,
    [12, 65]
    ,
    [13, 3]
    ,
    [13, 6]
    ,
    [13, 10]
    ,
    [13, 31]
    ,
    [13, 33]
    ,
    [13, 36]
    ,
    [13, 37]
    ,
    [13, 38]
    ,
    [13, 39]
    ,
    [13, 47]
    ,
    [13, 48]
    ,
    [13, 62]
    ,
    [13, 65]
    ,
    [14, 3]
    ,
    [14, 6]
    ,
    [14, 10]
    ,
    [14, 31]
    ,
    [14, 33]
    ,
    [14, 36]
    ,
    [14, 39]
    ,
    [14, 48]
    ,
    [14, 62]
    ,
    [14, 65]
    ,
    [14, 66]
    ,
    [15, 3]
    ,
    [15, 6]
    ,
    [15, 10]
    ,
    [15, 31]
    ,
    [15, 33]
    ,
    [15, 36]
    ,
    [15, 39]
    ,
    [15, 40]
    ,
    [15, 41]
    ,
    [15, 42]
    ,
    [15, 43]
    ,
    [15, 44]
    ,
    [15, 45]
    ,
    [15, 46]
    ,
    [15, 47]
    ,
    [15, 48]
    ,
    [15, 50]
    ,
    [15, 51]
    ,
    [15, 52]
    ,
    [15, 53]
    ,
    [15, 54]
    ,
    [15, 55]
    ,
    [15, 62]
    ,
    [15, 66]
    ,
    [16, 3]
    ,
    [16, 6]
    ,
    [16, 10]
    ,
    [16, 11]
    ,
    [16, 12]
    ,
    [16, 13]
    ,
    [16, 14]
    ,
    [16, 15]
    ,
    [16, 16]
    ,
    [16, 17]
    ,
    [16, 18]
    ,
    [16, 19]
    ,
    [16, 20]
    ,
    [16, 21]
    ,
    [16, 22]
    ,
    [16, 23]
    ,
    [16, 24]
    ,
    [16, 25]
    ,
    [16, 26]
    ,
    [16, 27]
    ,
    [16, 28]
    ,
    [16, 31]
    ,
    [16, 33]
    ,
    [16, 36]
    ,
    [16, 39]
    ,
    [16, 42]
    ,
    [16, 43]
    ,
    [16, 44]
    ,
    [16, 48]
    ,
    [16, 50]
    ,
    [16, 55]
    ,
    [16, 62]
    ,
    [16, 66]
    ,
    [17, 3]
    ,
    [17, 6]
    ,
    [17, 28]
    ,
    [17, 31]
    ,
    [17, 33]
    ,
    [17, 36]
    ,
    [17, 39]
    ,
    [17, 42]
    ,
    [17, 44]
    ,
    [17, 48]
    ,
    [17, 50]
    ,
    [17, 55]
    ,
    [17, 62]
    ,
    [17, 66]
    ,
    [18, 3]
    ,
    [18, 6]
    ,
    [18, 28]
    ,
    [18, 31]
    ,
    [18, 33]
    ,
    [18, 36]
    ,
    [18, 39]
    ,
    [18, 40]
    ,
    [18, 41]
    ,
    [18, 42]
    ,
    [18, 44]
    ,
    [18, 48]
    ,
    [18, 50]
    ,
    [18, 52]
    ,
    [18, 55]
    ,
    [18, 62]
    ,
    [18, 66]
    ,
    [19, 3]
    ,
    [19, 6]
    ,
    [19, 7]
    ,
    [19, 8]
    ,
    [19, 9]
    ,
    [19, 10]
    ,
    [19, 17]
    ,
    [19, 18]
    ,
    [19, 19]
    ,
    [19, 20]
    ,
    [19, 21]
    ,
    [19, 22]
    ,
    [19, 23]
    ,
    [19, 24]
    ,
    [19, 28]
    ,
    [19, 31]
    ,
    [19, 33]
    ,
    [19, 36]
    ,
    [19, 44]
    ,
    [19, 45]
    ,
    [19, 46]
    ,
    [19, 47]
    ,
    [19, 48]
    ,
    [19, 50]
    ,
    [19, 52]
    ,
    [19, 55]
    ,
    [19, 62]
    ,
    [19, 65]
    ,
    [19, 66]
    ,
    [20, 3]
    ,
    [20, 10]
    ,
    [20, 17]
    ,
    [20, 24]
    ,
    [20, 28]
    ,
    [20, 31]
    ,
    [20, 33]
    ,
    [20, 36]
    ,
    [20, 50]
    ,
    [20, 52]
    ,
    [20, 55]
    ,
    [20, 62]
    ,
    [20, 65]
    ,
    [21, 3]
    ,
    [21, 10]
    ,
    [21, 17]
    ,
    [21, 24]
    ,
    [21, 28]
    ,
    [21, 31]
    ,
    [21, 33]
    ,
    [21, 36]
    ,
    [21, 37]
    ,
    [21, 38]
    ,
    [21, 39]
    ,
    [21, 40]
    ,
    [21, 41]
    ,
    [21, 42]
    ,
    [21, 43]
    ,
    [21, 50]
    ,
    [21, 52]
    ,
    [21, 55]
    ,
    [21, 62]
    ,
    [21, 65]
    ,
    [22, 3]
    ,
    [22, 10]
    ,
    [22, 11]
    ,
    [22, 12]
    ,
    [22, 13]
    ,
    [22, 17]
    ,
    [22, 20]
    ,
    [22, 21]
    ,
    [22, 24]
    ,
    [22, 28]
    ,
    [22, 31]
    ,
    [22, 33]
    ,
    [22, 36]
    ,
    [22, 43]
    ,
    [22, 44]
    ,
    [22, 47]
    ,
    [22, 48]
    ,
    [22, 49]
    ,
    [22, 50]
    ,
    [22, 52]
    ,
    [22, 55]
    ,
    [22, 62]
    ,
    [22, 65]
    ,
    [23, 3]
    ,
    [23, 4]
    ,
    [23, 5]
    ,
    [23, 6]
    ,
    [23, 13]
    ,
    [23, 17]
    ,
    [23, 20]
    ,
    [23, 21]
    ,
    [23, 24]
    ,
    [23, 28]
    ,
    [23, 31]
    ,
    [23, 33]
    ,
    [23, 36]
    ,
    [23, 44]
    ,
    [23, 47]
    ,
    [23, 52]
    ,
    [23, 55]
    ,
    [23, 62]
    ,
    [23, 65]
    ,
    [24, 6]
    ,
    [24, 13]
    ,
    [24, 17]
    ,
    [24, 20]
    ,
    [24, 21]
    ,
    [24, 24]
    ,
    [24, 28]
    ,
    [24, 31]
    ,
    [24, 33]
    ,
    [24, 36]
    ,
    [24, 39]
    ,
    [24, 40]
    ,
    [24, 41]
    ,
    [24, 44]
    ,
    [24, 45]
    ,
    [24, 46]
    ,
    [24, 47]
    ,
    [24, 52]
    ,
    [24, 55]
    ,
    [24, 56]
    ,
    [24, 57]
    ,
    [24, 58]
    ,
    [24, 59]
    ,
    [24, 60]
    ,
    [24, 61]
    ,
    [24, 62]
    ,
    [24, 65]
    ,
    [25, 6]
    ,
    [25, 13]
    ,
    [25, 14]
    ,
    [25, 15]
    ,
    [25, 16]
    ,
    [25, 17]
    ,
    [25, 20]
    ,
    [25, 21]
    ,
    [25, 24]
    ,
    [25, 25]
    ,
    [25, 26]
    ,
    [25, 27]
    ,
    [25, 28]
    ,
    [25, 31]
    ,
    [25, 33]
    ,
    [25, 36]
    ,
    [25, 39]
    ,
    [25, 41]
    ,
    [25, 50]
    ,
    [25, 51]
    ,
    [25, 52]
    ,
    [25, 53]
    ,
    [25, 65]
    ,
    [26, 6]
    ,
    [26, 20]
    ,
    [26, 21]
    ,
    [26, 31]
    ,
    [26, 33]
    ,
    [26, 39]
    ,
    [26, 42]
    ,
    [26, 49]
    ,
    [26, 53]
    ,
    [26, 64]
    ,
    [26, 65]
    ,
    [27, 6]
    ,
    [27, 20]
    ,
    [27, 21]
    ,
    [27, 31]
    ,
    [27, 33]
    ,
    [27, 39]
    ,
    [27, 42]
    ,
    [27, 49]
    ,
    [27, 53]
    ,
    [27, 54]
    ,
    [27, 60]
    ,
    [27, 61]
    ,
    [27, 62]
    ,
    [27, 63]
    ,
    [27, 64]
    ,
    [28, 6]
    ,
    [28, 7]
    ,
    [28, 8]
    ,
    [28, 9]
    ,
    [28, 10]
    ,
    [28, 11]
    ,
    [28, 12]
    ,
    [28, 13]
    ,
    [28, 14]
    ,
    [28, 15]
    ,
    [28, 16]
    ,
    [28, 17]
    ,
    [28, 18]
    ,
    [28, 19]
    ,
    [28, 20]
    ,
    [28, 21]
    ,
    [28, 22]
    ,
    [28, 23]
    ,
    [28, 24]
    ,
    [28, 25]
    ,
    [28, 26]
    ,
    [28, 27]
    ,
    [28, 28]
    ,
    [28, 29]
    ,
    [28, 30]
    ,
    [28, 31]
    ,
    [28, 33]
    ,
    [28, 34]
    ,
    [28, 35]
    ,
    [28, 36]
    ,
    [28, 37]
    ,
    [28, 38]
    ,
    [28, 39]
    ,
    [28, 42]
    ,
    [28, 43]
    ,
    [28, 44]
    ,
    [28, 45]
    ,
    [28, 46]
    ,
    [28, 47]
    ,
    [28, 48]
    ,
    [28, 49]
    ,
    [28, 54]
    ,
    [28, 55]
    ,
    [28, 56]
    ,
    [28, 57]
    ,
    [28, 58]
    ,
    [28, 59]
    ,
    [28, 60]
];

export default points;